import { gql } from '@apollo/client';
import { DeleteUserInput } from './types';

/**
 * GraphQL mutation to delete a user
 */
export const DELETE_USER = gql`
  mutation DeleteUser($input: DeleteUserInput!) {
    deleteUser(input: $input) {
      deletedId
      user {
        id
        databaseId
        name
        email
      }
    }
  }
`;

export interface DeleteUserData {
  deleteUser: {
    deletedId: string;
    user: Pick<import('../../queries/users/types').User, 'id' | 'databaseId' | 'name' | 'email'>;
  };
}

export interface DeleteUserVariables {
  input: DeleteUserInput;
}
